var s;!function(s){s.website="website",s.noCustomClass="noCustomClass"}(s||(s={}));export{s as classNamesType};
//# sourceMappingURL=input.types.js.map
